// pages/Login.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('This is a design mockup. Login functionality will be implemented with a backend.');
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="nav-mark">F</div>
          FaithConnect
        </div>
        <h1>Welcome back</h1>
        <p className="sub">Log in to manage your church member care.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <Link to="#" className="forgot-link">Forgot password?</Link>
          </div>
          <button type="submit" className="btn-primary form-submit">Log in</button>
        </form>

        <div className="auth-divider">or continue with</div>
        <button className="auth-social" style={{ background: 'none', border: '1px solid var(--border)', cursor: 'pointer' }}>
          <span>🔑</span> Google
        </button>

        <div className="auth-footer-link">
          Don't have an account? <Link to="/signup">Sign up for free</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;